import { render, staticRenderFns } from "./GrantSearchFilterResetButton.vue?vue&type=template&id=b578d72c&scoped=true&"
import script from "./GrantSearchFilterResetButton.vue?vue&type=script&lang=js&"
export * from "./GrantSearchFilterResetButton.vue?vue&type=script&lang=js&"
import style0 from "./GrantSearchFilterResetButton.vue?vue&type=style&index=0&id=b578d72c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b578d72c",
  null
  
)

export default component.exports